(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js', './boislocal-platform-platform-infra-commons-commons-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'.");
    }
    root['boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'] = factory(typeof this['boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['boislocal-platform-platform-infra-commons-commons-domain']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs, kotlin_org_boislocal_commons_domain) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var protoOf = kotlin_kotlin.$_$.fa;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var THROW_IAE = kotlin_kotlin.$_$.ld;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.zc;
  var defineProp = kotlin_kotlin.$_$.b9;
  var S2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.j;
  var classMeta = kotlin_kotlin.$_$.z8;
  var S2TransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.b;
  var toValue = kotlin_io_komune_s2_s2_automate_dsl.$_$.m;
  var toValue_0 = kotlin_io_komune_s2_s2_automate_dsl.$_$.n;
  var getKClass = kotlin_kotlin.$_$.f;
  var toValue_1 = kotlin_io_komune_s2_s2_automate_dsl.$_$.l;
  var S2Transition = kotlin_io_komune_s2_s2_automate_dsl.$_$.k;
  var S2SelfTransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.a;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.j5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var s2Sourcing = kotlin_io_komune_s2_s2_automate_dsl.$_$.c;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.da;
  var S2Role = kotlin_io_komune_s2_s2_automate_dsl.$_$.i;
  var S2InitCommand = kotlin_io_komune_s2_s2_automate_dsl.$_$.h;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var toString = kotlin_kotlin.$_$.le;
  var equals = kotlin_kotlin.$_$.c9;
  var S2Command = kotlin_io_komune_s2_s2_automate_dsl.$_$.g;
  var Long = kotlin_kotlin.$_$.ed;
  var WithS2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.f;
  var Roles_instance = kotlin_org_boislocal_commons_domain.$_$.b;
  var hasRole = kotlin_org_boislocal_commons_domain.$_$.m;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var isAvailableTransition = kotlin_io_komune_s2_s2_automate_dsl.$_$.d;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(OuvrageTypeState, 'OuvrageTypeState', classMeta, Enum, [Enum, S2State], VOID, VOID, {0: Companion_getInstance});
  setMetadataFor(S2, 'S2', objectMeta);
  setMetadataFor(UserRole, 'UserRole', classMeta, VOID, [S2Role], VOID, VOID, {0: $serializer_getInstance});
  setMetadataFor(User, 'User', objectMeta, UserRole);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageTypeCreateCommandDTO, 'OuvrageTypeCreateCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(OuvrageTypeCreatedEventDTO, 'OuvrageTypeCreatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageTypeCreateCommand, 'OuvrageTypeCreateCommand', classMeta, VOID, [OuvrageTypeCreateCommandDTO], VOID, VOID, {0: $serializer_getInstance_0});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageTypeCreatedEvent, 'OuvrageTypeCreatedEvent', classMeta, VOID, [OuvrageTypeCreatedEventDTO], VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(OuvrageTypeDeleteCommandDTO, 'OuvrageTypeDeleteCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(OuvrageTypeDeletedEventDTO, 'OuvrageTypeDeletedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageTypeDeleteCommand, 'OuvrageTypeDeleteCommand', classMeta, VOID, [OuvrageTypeDeleteCommandDTO], VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageTypeDeletedEvent, 'OuvrageTypeDeletedEvent', classMeta, VOID, [OuvrageTypeDeletedEventDTO], VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(OuvrageTypeImportCommandDTO, 'OuvrageTypeImportCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(OuvrageTypeImportedEventDTO, 'OuvrageTypeImportedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageTypeImportCommand, 'OuvrageTypeImportCommand', classMeta, VOID, [OuvrageTypeImportCommandDTO], VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageTypeImportedEvent, 'OuvrageTypeImportedEvent', classMeta, VOID, [OuvrageTypeImportedEventDTO], VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(OuvrageTypeUpdateCommandDTO, 'OuvrageTypeUpdateCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(OuvrageTypeUpdatedEventDTO, 'OuvrageTypeUpdatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageTypeUpdateCommand, 'OuvrageTypeUpdateCommand', classMeta, VOID, [OuvrageTypeUpdateCommandDTO], VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageTypeUpdatedEvent, 'OuvrageTypeUpdatedEvent', classMeta, VOID, [OuvrageTypeUpdatedEventDTO], VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(OuvrageTypeModelDTO, 'OuvrageTypeModelDTO', interfaceMeta, VOID, [WithS2State, WithS2Id]);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageTypeModel, 'OuvrageTypeModel', classMeta, VOID, [OuvrageTypeModelDTO], VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(OuvrageTypePolicies, 'OuvrageTypePolicies', objectMeta);
  setMetadataFor(OuvrageTypeGetQueryDTO, 'OuvrageTypeGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(OuvrageTypeGetResponseDTO, 'OuvrageTypeGetResponseDTO', interfaceMeta);
  setMetadataFor(OuvrageTypePageQueryDTO, 'OuvrageTypePageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(OuvrageTypePageResponseDTO, 'OuvrageTypePageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.d2g_1.f2();
  }
  function OuvrageTypeState$Companion$_anonymous__zrsmt() {
    return createSimpleEnumSerializer('org.boislocal.platform.s2.ouvrageType.domain.automate.OuvrageTypeState', values());
  }
  var OuvrageTypeState_Exists_instance;
  var OuvrageTypeState_Deleted_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d2g_1 = lazy(tmp_0, OuvrageTypeState$Companion$_anonymous__zrsmt);
  }
  protoOf(Companion).x14 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var Companion_instance;
  function Companion_getInstance() {
    OuvrageTypeState_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [OuvrageTypeState_Exists_getInstance(), OuvrageTypeState_Deleted_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Exists':
        return OuvrageTypeState_Exists_getInstance();
      case 'Deleted':
        return OuvrageTypeState_Deleted_getInstance();
      default:
        OuvrageTypeState_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var OuvrageTypeState_entriesInitialized;
  function OuvrageTypeState_initEntries() {
    if (OuvrageTypeState_entriesInitialized)
      return Unit_instance;
    OuvrageTypeState_entriesInitialized = true;
    OuvrageTypeState_Exists_instance = new OuvrageTypeState('Exists', 0, 0);
    OuvrageTypeState_Deleted_instance = new OuvrageTypeState('Deleted', 1, 1);
    Companion_getInstance();
  }
  function OuvrageTypeState(name, ordinal, position) {
    Enum.call(this, name, ordinal);
    this.g2g_1 = position;
  }
  protoOf(OuvrageTypeState).y2c = function (_set____db54di) {
    this.g2g_1 = _set____db54di;
  };
  protoOf(OuvrageTypeState).jr = function () {
    return this.g2g_1;
  };
  function S2$ouvrageTypeAutomate$lambda($this$s2Sourcing) {
    $this$s2Sourcing.j27_1 = 'OuvrageType';
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.ouvrageType.domain.automate.S2.ouvrageTypeAutomate.<anonymous>.<anonymous>' call
    builder.o27_1 = OuvrageTypeState_Exists_getInstance();
    builder.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = builder.m27_1;
    var tmp = tmp0_safe_receiver == null ? null : toValue(tmp0_safe_receiver);
    var tmp_0 = toValue(builder.c24());
    var tmp_1 = toValue_0(builder.d24());
    var tmp_2 = toValue_1(getKClass(OuvrageTypeImportCommand));
    var tmp1_elvis_lhs = builder.q27_1;
    var this_0 = new S2Transition(tmp, tmp_0, tmp_1, tmp_2, toValue_1(tmp1_elvis_lhs == null ? getKClass(OuvrageTypeImportedEvent) : tmp1_elvis_lhs));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_0);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_0 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.ouvrageType.domain.automate.S2.ouvrageTypeAutomate.<anonymous>.<anonymous>' call
    builder_0.o27_1 = OuvrageTypeState_Deleted_getInstance();
    builder_0.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = builder_0.m27_1;
    var tmp_3 = tmp0_safe_receiver_0 == null ? null : toValue(tmp0_safe_receiver_0);
    var tmp_4 = toValue(builder_0.c24());
    var tmp_5 = toValue_0(builder_0.d24());
    var tmp_6 = toValue_1(getKClass(OuvrageTypeImportCommand));
    var tmp1_elvis_lhs_0 = builder_0.q27_1;
    var this_1 = new S2Transition(tmp_3, tmp_4, tmp_5, tmp_6, toValue_1(tmp1_elvis_lhs_0 == null ? getKClass(OuvrageTypeImportedEvent) : tmp1_elvis_lhs_0));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_1);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_1 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.ouvrageType.domain.automate.S2.ouvrageTypeAutomate.<anonymous>.<anonymous>' call
    builder_1.o27_1 = OuvrageTypeState_Exists_getInstance();
    builder_1.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_1 = builder_1.m27_1;
    var tmp_7 = tmp0_safe_receiver_1 == null ? null : toValue(tmp0_safe_receiver_1);
    var tmp_8 = toValue(builder_1.c24());
    var tmp_9 = toValue_0(builder_1.d24());
    var tmp_10 = toValue_1(getKClass(OuvrageTypeCreateCommand));
    var tmp1_elvis_lhs_1 = builder_1.q27_1;
    var this_2 = new S2Transition(tmp_7, tmp_8, tmp_9, tmp_10, toValue_1(tmp1_elvis_lhs_1 == null ? getKClass(OuvrageTypeCreatedEvent) : tmp1_elvis_lhs_1));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_2);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_2 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.ouvrageType.domain.automate.S2.ouvrageTypeAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_3 = builder_2.r27_1;
    var element = OuvrageTypeState_Exists_getInstance();
    this_3.r(element);
    builder_2.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_4 = builder_2.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
    var tmp0_iterator = this_4.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_11 = toValue(item);
      var tmp_12 = toValue(item);
      var tmp_13 = toValue_0(builder_2.d24());
      var tmp_14 = toValue_1(getKClass(OuvrageTypeUpdateCommand));
      var tmp0_elvis_lhs = builder_2.t27_1;
      var tmp$ret$6 = new S2Transition(tmp_11, tmp_12, tmp_13, tmp_14, toValue_1(tmp0_elvis_lhs == null ? getKClass(OuvrageTypeUpdatedEvent) : tmp0_elvis_lhs));
      destination.r(tmp$ret$6);
    }
    var tmp3_forEach_receiver = $this$s2Sourcing.l27_1;
    var tmp0_iterator_0 = destination.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.w();
      invoke$add(tmp3_forEach_receiver, element_0);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_3 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.ouvrageType.domain.automate.S2.ouvrageTypeAutomate.<anonymous>.<anonymous>' call
    builder_3.m27_1 = OuvrageTypeState_Exists_getInstance();
    builder_3.o27_1 = OuvrageTypeState_Deleted_getInstance();
    builder_3.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_2 = builder_3.m27_1;
    var tmp_15 = tmp0_safe_receiver_2 == null ? null : toValue(tmp0_safe_receiver_2);
    var tmp_16 = toValue(builder_3.c24());
    var tmp_17 = toValue_0(builder_3.d24());
    var tmp_18 = toValue_1(getKClass(OuvrageTypeDeleteCommand));
    var tmp1_elvis_lhs_2 = builder_3.q27_1;
    var this_5 = new S2Transition(tmp_15, tmp_16, tmp_17, tmp_18, toValue_1(tmp1_elvis_lhs_2 == null ? getKClass(OuvrageTypeDeletedEvent) : tmp1_elvis_lhs_2));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_5);
    return Unit_instance;
  }
  function invoke$add(receiver, p0) {
    receiver.r(p0);
  }
  function S2() {
    S2_instance = this;
    var tmp = this;
    tmp.h2g_1 = s2Sourcing(S2$ouvrageTypeAutomate$lambda);
  }
  var S2_instance;
  function S2_getInstance() {
    if (S2_instance == null)
      new S2();
    return S2_instance;
  }
  function User() {
    User_instance = this;
    UserRole.call(this, 'User');
  }
  var User_instance;
  function User_getInstance() {
    if (User_instance == null)
      new User();
    return User_instance;
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.ouvrageType.domain.automate.UserRole', this, 1);
    tmp0_serialDesc.ht('name', false);
    this.j2g_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.j2g_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.j2g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return UserRole_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).k2g = function (encoder, value) {
    var tmp0_desc = this.j2g_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h9());
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.k2g(encoder, value instanceof UserRole ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function UserRole_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance().j2g_1);
    }
    $this.i2g_1 = name;
    return $this;
  }
  function UserRole_init_$Create$(seen1, name, serializationConstructorMarker) {
    return UserRole_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(UserRole)));
  }
  function UserRole(name) {
    this.i2g_1 = name;
  }
  protoOf(UserRole).h9 = function () {
    return this.i2g_1;
  };
  protoOf(UserRole).toString = function () {
    return this.h9();
  };
  function OuvrageTypeState_Exists_getInstance() {
    OuvrageTypeState_initEntries();
    return OuvrageTypeState_Exists_instance;
  }
  function OuvrageTypeState_Deleted_getInstance() {
    OuvrageTypeState_initEntries();
    return OuvrageTypeState_Deleted_instance;
  }
  function OuvrageTypeCreateCommandDTO() {
  }
  function OuvrageTypeCreatedEventDTO() {
  }
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.ouvrageType.domain.command.OuvrageTypeCreateCommand', this, 1);
    tmp0_serialDesc.ht('name', false);
    this.l2g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.l2g_1;
  };
  protoOf($serializer_0).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.l2g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return OuvrageTypeCreateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_0).m2g = function (encoder, value) {
    var tmp0_desc = this.l2g_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.n2g_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.m2g(encoder, value instanceof OuvrageTypeCreateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function OuvrageTypeCreateCommand_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_0().l2g_1);
    }
    $this.n2g_1 = name;
    return $this;
  }
  function OuvrageTypeCreateCommand_init_$Create$(seen1, name, serializationConstructorMarker) {
    return OuvrageTypeCreateCommand_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(OuvrageTypeCreateCommand)));
  }
  function OuvrageTypeCreateCommand(name) {
    this.n2g_1 = name;
  }
  protoOf(OuvrageTypeCreateCommand).h9 = function () {
    return this.n2g_1;
  };
  protoOf(OuvrageTypeCreateCommand).toString = function () {
    return 'OuvrageTypeCreateCommand(name=' + this.n2g_1 + ')';
  };
  protoOf(OuvrageTypeCreateCommand).hashCode = function () {
    return getStringHashCode(this.n2g_1);
  };
  protoOf(OuvrageTypeCreateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageTypeCreateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageTypeCreateCommand ? other : THROW_CCE();
    if (!(this.n2g_1 === tmp0_other_with_cast.n2g_1))
      return false;
    return true;
  };
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OuvrageTypeCreatedEvent', this, 3);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('time', false);
    this.o2g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.o2g_1;
  };
  protoOf($serializer_1).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.o2g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.im(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.im(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return OuvrageTypeCreatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_1).p2g = function (encoder, value) {
    var tmp0_desc = this.o2g_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.q2g_1);
    tmp1_output.jn(tmp0_desc, 1, value.r2g_1);
    tmp1_output.nn(tmp0_desc, 2, LongSerializer_getInstance(), value.s2g_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.p2g(encoder, value instanceof OuvrageTypeCreatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function OuvrageTypeCreatedEvent_init_$Init$(seen1, id, name, time, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_1().o2g_1);
    }
    $this.q2g_1 = id;
    $this.r2g_1 = name;
    $this.s2g_1 = time;
    return $this;
  }
  function OuvrageTypeCreatedEvent_init_$Create$(seen1, id, name, time, serializationConstructorMarker) {
    return OuvrageTypeCreatedEvent_init_$Init$(seen1, id, name, time, serializationConstructorMarker, objectCreate(protoOf(OuvrageTypeCreatedEvent)));
  }
  function OuvrageTypeCreatedEvent(id, name, time) {
    this.q2g_1 = id;
    this.r2g_1 = name;
    this.s2g_1 = time;
  }
  protoOf(OuvrageTypeCreatedEvent).k1y = function () {
    return this.q2g_1;
  };
  protoOf(OuvrageTypeCreatedEvent).h9 = function () {
    return this.r2g_1;
  };
  protoOf(OuvrageTypeCreatedEvent).g2c = function () {
    return this.s2g_1;
  };
  protoOf(OuvrageTypeCreatedEvent).s2Id = function () {
    return this.q2g_1;
  };
  protoOf(OuvrageTypeCreatedEvent).toString = function () {
    return 'OuvrageTypeCreatedEvent(id=' + this.q2g_1 + ', name=' + this.r2g_1 + ', time=' + toString(this.s2g_1) + ')';
  };
  protoOf(OuvrageTypeCreatedEvent).hashCode = function () {
    var result = getStringHashCode(this.q2g_1);
    result = imul(result, 31) + getStringHashCode(this.r2g_1) | 0;
    result = imul(result, 31) + (this.s2g_1 == null ? 0 : this.s2g_1.hashCode()) | 0;
    return result;
  };
  protoOf(OuvrageTypeCreatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageTypeCreatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageTypeCreatedEvent ? other : THROW_CCE();
    if (!(this.q2g_1 === tmp0_other_with_cast.q2g_1))
      return false;
    if (!(this.r2g_1 === tmp0_other_with_cast.r2g_1))
      return false;
    if (!equals(this.s2g_1, tmp0_other_with_cast.s2g_1))
      return false;
    return true;
  };
  function OuvrageTypeDeleteCommandDTO() {
  }
  function OuvrageTypeDeletedEventDTO() {
  }
  function Companion_3() {
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.ouvrageType.domain.command.OuvrageTypeDeleteCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.t2g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.t2g_1;
  };
  protoOf($serializer_2).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.t2g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return OuvrageTypeDeleteCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_2).u2g = function (encoder, value) {
    var tmp0_desc = this.t2g_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.v2g_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.u2g(encoder, value instanceof OuvrageTypeDeleteCommand ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function OuvrageTypeDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_2().t2g_1);
    }
    $this.v2g_1 = id;
    return $this;
  }
  function OuvrageTypeDeleteCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return OuvrageTypeDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(OuvrageTypeDeleteCommand)));
  }
  function OuvrageTypeDeleteCommand(id) {
    this.v2g_1 = id;
  }
  protoOf(OuvrageTypeDeleteCommand).k1y = function () {
    return this.v2g_1;
  };
  protoOf(OuvrageTypeDeleteCommand).toString = function () {
    return 'OuvrageTypeDeleteCommand(id=' + this.v2g_1 + ')';
  };
  protoOf(OuvrageTypeDeleteCommand).hashCode = function () {
    return getStringHashCode(this.v2g_1);
  };
  protoOf(OuvrageTypeDeleteCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageTypeDeleteCommand))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageTypeDeleteCommand ? other : THROW_CCE();
    if (!(this.v2g_1 === tmp0_other_with_cast.v2g_1))
      return false;
    return true;
  };
  function Companion_4() {
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OuvrageTypeDeletedEvent', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('time', false);
    this.w2g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.w2g_1;
  };
  protoOf($serializer_3).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.w2g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return OuvrageTypeDeletedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).x2g = function (encoder, value) {
    var tmp0_desc = this.w2g_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.y2g_1);
    tmp1_output.nn(tmp0_desc, 1, LongSerializer_getInstance(), value.z2g_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.x2g(encoder, value instanceof OuvrageTypeDeletedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function OuvrageTypeDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_3().w2g_1);
    }
    $this.y2g_1 = id;
    $this.z2g_1 = time;
    return $this;
  }
  function OuvrageTypeDeletedEvent_init_$Create$(seen1, id, time, serializationConstructorMarker) {
    return OuvrageTypeDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, objectCreate(protoOf(OuvrageTypeDeletedEvent)));
  }
  function OuvrageTypeDeletedEvent(id, time) {
    this.y2g_1 = id;
    this.z2g_1 = time;
  }
  protoOf(OuvrageTypeDeletedEvent).k1y = function () {
    return this.y2g_1;
  };
  protoOf(OuvrageTypeDeletedEvent).g2c = function () {
    return this.z2g_1;
  };
  protoOf(OuvrageTypeDeletedEvent).s2Id = function () {
    return this.y2g_1;
  };
  protoOf(OuvrageTypeDeletedEvent).toString = function () {
    return 'OuvrageTypeDeletedEvent(id=' + this.y2g_1 + ', time=' + toString(this.z2g_1) + ')';
  };
  protoOf(OuvrageTypeDeletedEvent).hashCode = function () {
    var result = getStringHashCode(this.y2g_1);
    result = imul(result, 31) + (this.z2g_1 == null ? 0 : this.z2g_1.hashCode()) | 0;
    return result;
  };
  protoOf(OuvrageTypeDeletedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageTypeDeletedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageTypeDeletedEvent ? other : THROW_CCE();
    if (!(this.y2g_1 === tmp0_other_with_cast.y2g_1))
      return false;
    if (!equals(this.z2g_1, tmp0_other_with_cast.z2g_1))
      return false;
    return true;
  };
  function OuvrageTypeImportCommandDTO() {
  }
  function OuvrageTypeImportedEventDTO() {
  }
  function Companion_5() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.ouvrageType.domain.command.OuvrageTypeImportCommand', this, 1);
    tmp0_serialDesc.ht('item', false);
    this.a2h_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ii = function () {
    return this.a2h_1;
  };
  protoOf($serializer_4).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_8()];
  };
  protoOf($serializer_4).ki = function (decoder) {
    var tmp0_desc = this.a2h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return OuvrageTypeImportCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_4).b2h = function (encoder, value) {
    var tmp0_desc = this.a2h_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_8(), value.c2h_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_4).ji = function (encoder, value) {
    return this.b2h(encoder, value instanceof OuvrageTypeImportCommand ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function OuvrageTypeImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_4().a2h_1);
    }
    $this.c2h_1 = item;
    return $this;
  }
  function OuvrageTypeImportCommand_init_$Create$(seen1, item, serializationConstructorMarker) {
    return OuvrageTypeImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, objectCreate(protoOf(OuvrageTypeImportCommand)));
  }
  function OuvrageTypeImportCommand(item) {
    this.c2h_1 = item;
  }
  protoOf(OuvrageTypeImportCommand).q20 = function () {
    return this.c2h_1;
  };
  protoOf(OuvrageTypeImportCommand).toString = function () {
    return 'OuvrageTypeImportCommand(item=' + this.c2h_1 + ')';
  };
  protoOf(OuvrageTypeImportCommand).hashCode = function () {
    return this.c2h_1.hashCode();
  };
  protoOf(OuvrageTypeImportCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageTypeImportCommand))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageTypeImportCommand ? other : THROW_CCE();
    if (!this.c2h_1.equals(tmp0_other_with_cast.c2h_1))
      return false;
    return true;
  };
  function Companion_6() {
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OuvrageTypeImportedEvent', this, 2);
    tmp0_serialDesc.ht('item', false);
    tmp0_serialDesc.ht('time', false);
    this.d2h_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ii = function () {
    return this.d2h_1;
  };
  protoOf($serializer_5).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_8(), LongSerializer_getInstance()];
  };
  protoOf($serializer_5).ki = function (decoder) {
    var tmp0_desc = this.d2h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_8(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return OuvrageTypeImportedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_5).e2h = function (encoder, value) {
    var tmp0_desc = this.d2h_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_8(), value.f2h_1);
    tmp1_output.fn(tmp0_desc, 1, value.g2h_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_5).ji = function (encoder, value) {
    return this.e2h(encoder, value instanceof OuvrageTypeImportedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function OuvrageTypeImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_5().d2h_1);
    }
    $this.f2h_1 = item;
    $this.g2h_1 = time;
    return $this;
  }
  function OuvrageTypeImportedEvent_init_$Create$(seen1, item, time, serializationConstructorMarker) {
    return OuvrageTypeImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, objectCreate(protoOf(OuvrageTypeImportedEvent)));
  }
  function OuvrageTypeImportedEvent(item, time) {
    this.f2h_1 = item;
    this.g2h_1 = time;
  }
  protoOf(OuvrageTypeImportedEvent).q20 = function () {
    return this.f2h_1;
  };
  protoOf(OuvrageTypeImportedEvent).g2c = function () {
    return this.g2h_1;
  };
  protoOf(OuvrageTypeImportedEvent).s2Id = function () {
    return this.f2h_1.h2h_1;
  };
  protoOf(OuvrageTypeImportedEvent).toString = function () {
    return 'OuvrageTypeImportedEvent(item=' + this.f2h_1 + ', time=' + this.g2h_1.toString() + ')';
  };
  protoOf(OuvrageTypeImportedEvent).hashCode = function () {
    var result = this.f2h_1.hashCode();
    result = imul(result, 31) + this.g2h_1.hashCode() | 0;
    return result;
  };
  protoOf(OuvrageTypeImportedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageTypeImportedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageTypeImportedEvent ? other : THROW_CCE();
    if (!this.f2h_1.equals(tmp0_other_with_cast.f2h_1))
      return false;
    if (!this.g2h_1.equals(tmp0_other_with_cast.g2h_1))
      return false;
    return true;
  };
  function OuvrageTypeUpdateCommandDTO() {
  }
  function OuvrageTypeUpdatedEventDTO() {
  }
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.ouvrageType.domain.command.OuvrageTypeUpdateCommand', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    this.m2h_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ii = function () {
    return this.m2h_1;
  };
  protoOf($serializer_6).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  protoOf($serializer_6).ki = function (decoder) {
    var tmp0_desc = this.m2h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return OuvrageTypeUpdateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_6).n2h = function (encoder, value) {
    var tmp0_desc = this.m2h_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.o2h_1);
    tmp1_output.jn(tmp0_desc, 1, value.p2h_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_6).ji = function (encoder, value) {
    return this.n2h(encoder, value instanceof OuvrageTypeUpdateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function OuvrageTypeUpdateCommand_init_$Init$(seen1, id, name, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_6().m2h_1);
    }
    $this.o2h_1 = id;
    $this.p2h_1 = name;
    return $this;
  }
  function OuvrageTypeUpdateCommand_init_$Create$(seen1, id, name, serializationConstructorMarker) {
    return OuvrageTypeUpdateCommand_init_$Init$(seen1, id, name, serializationConstructorMarker, objectCreate(protoOf(OuvrageTypeUpdateCommand)));
  }
  function OuvrageTypeUpdateCommand(id, name) {
    this.o2h_1 = id;
    this.p2h_1 = name;
  }
  protoOf(OuvrageTypeUpdateCommand).k1y = function () {
    return this.o2h_1;
  };
  protoOf(OuvrageTypeUpdateCommand).h9 = function () {
    return this.p2h_1;
  };
  protoOf(OuvrageTypeUpdateCommand).toString = function () {
    return 'OuvrageTypeUpdateCommand(id=' + this.o2h_1 + ', name=' + this.p2h_1 + ')';
  };
  protoOf(OuvrageTypeUpdateCommand).hashCode = function () {
    var result = getStringHashCode(this.o2h_1);
    result = imul(result, 31) + getStringHashCode(this.p2h_1) | 0;
    return result;
  };
  protoOf(OuvrageTypeUpdateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageTypeUpdateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageTypeUpdateCommand ? other : THROW_CCE();
    if (!(this.o2h_1 === tmp0_other_with_cast.o2h_1))
      return false;
    if (!(this.p2h_1 === tmp0_other_with_cast.p2h_1))
      return false;
    return true;
  };
  function Companion_8() {
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OuvrageTypeUpdatedEvent', this, 3);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('time', false);
    this.q2h_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ii = function () {
    return this.q2h_1;
  };
  protoOf($serializer_7).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_7).ki = function (decoder) {
    var tmp0_desc = this.q2h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.im(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.im(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return OuvrageTypeUpdatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_7).r2h = function (encoder, value) {
    var tmp0_desc = this.q2h_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.s2h_1);
    tmp1_output.jn(tmp0_desc, 1, value.t2h_1);
    tmp1_output.nn(tmp0_desc, 2, LongSerializer_getInstance(), value.u2h_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_7).ji = function (encoder, value) {
    return this.r2h(encoder, value instanceof OuvrageTypeUpdatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function OuvrageTypeUpdatedEvent_init_$Init$(seen1, id, name, time, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_7().q2h_1);
    }
    $this.s2h_1 = id;
    $this.t2h_1 = name;
    $this.u2h_1 = time;
    return $this;
  }
  function OuvrageTypeUpdatedEvent_init_$Create$(seen1, id, name, time, serializationConstructorMarker) {
    return OuvrageTypeUpdatedEvent_init_$Init$(seen1, id, name, time, serializationConstructorMarker, objectCreate(protoOf(OuvrageTypeUpdatedEvent)));
  }
  function OuvrageTypeUpdatedEvent(id, name, time) {
    this.s2h_1 = id;
    this.t2h_1 = name;
    this.u2h_1 = time;
  }
  protoOf(OuvrageTypeUpdatedEvent).k1y = function () {
    return this.s2h_1;
  };
  protoOf(OuvrageTypeUpdatedEvent).h9 = function () {
    return this.t2h_1;
  };
  protoOf(OuvrageTypeUpdatedEvent).g2c = function () {
    return this.u2h_1;
  };
  protoOf(OuvrageTypeUpdatedEvent).s2Id = function () {
    return this.s2h_1;
  };
  protoOf(OuvrageTypeUpdatedEvent).toString = function () {
    return 'OuvrageTypeUpdatedEvent(id=' + this.s2h_1 + ', name=' + this.t2h_1 + ', time=' + toString(this.u2h_1) + ')';
  };
  protoOf(OuvrageTypeUpdatedEvent).hashCode = function () {
    var result = getStringHashCode(this.s2h_1);
    result = imul(result, 31) + getStringHashCode(this.t2h_1) | 0;
    result = imul(result, 31) + (this.u2h_1 == null ? 0 : this.u2h_1.hashCode()) | 0;
    return result;
  };
  protoOf(OuvrageTypeUpdatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageTypeUpdatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageTypeUpdatedEvent ? other : THROW_CCE();
    if (!(this.s2h_1 === tmp0_other_with_cast.s2h_1))
      return false;
    if (!(this.t2h_1 === tmp0_other_with_cast.t2h_1))
      return false;
    if (!equals(this.u2h_1, tmp0_other_with_cast.u2h_1))
      return false;
    return true;
  };
  function OuvrageTypeModelDTO() {
  }
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x2h_1 = [null, Companion_getInstance().x14(), null, null, null];
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.ouvrageType.domain.model.OuvrageTypeModel', this, 5);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('creationDate', false);
    tmp0_serialDesc.ht('updatedDate', false);
    this.y2h_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).ii = function () {
    return this.y2h_1;
  };
  protoOf($serializer_8).wt = function () {
    var tmp0_cached = Companion_getInstance_9().x2h_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_8).ki = function (decoder) {
    var tmp0_desc = this.y2h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.ul(tmp0_desc);
    var tmp10_cached = Companion_getInstance_9().x2h_1;
    if (tmp9_input.km()) {
      tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.gm(tmp0_desc, 1, tmp10_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.gm(tmp0_desc, 1, tmp10_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.vl(tmp0_desc);
    return OuvrageTypeModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_8).z2h = function (encoder, value) {
    var tmp0_desc = this.y2h_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_9().x2h_1;
    tmp1_output.jn(tmp0_desc, 0, value.h2h_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.i2h_1);
    tmp1_output.jn(tmp0_desc, 2, value.j2h_1);
    tmp1_output.nn(tmp0_desc, 3, LongSerializer_getInstance(), value.k2h_1);
    tmp1_output.nn(tmp0_desc, 4, LongSerializer_getInstance(), value.l2h_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_8).ji = function (encoder, value) {
    return this.z2h(encoder, value instanceof OuvrageTypeModel ? value : THROW_CCE());
  };
  var $serializer_instance_8;
  function $serializer_getInstance_8() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function OuvrageTypeModel_init_$Init$(seen1, id, status, name, creationDate, updatedDate, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen1))) {
      throwMissingFieldException(seen1, 31, $serializer_getInstance_8().y2h_1);
    }
    $this.h2h_1 = id;
    $this.i2h_1 = status;
    $this.j2h_1 = name;
    $this.k2h_1 = creationDate;
    $this.l2h_1 = updatedDate;
    return $this;
  }
  function OuvrageTypeModel_init_$Create$(seen1, id, status, name, creationDate, updatedDate, serializationConstructorMarker) {
    return OuvrageTypeModel_init_$Init$(seen1, id, status, name, creationDate, updatedDate, serializationConstructorMarker, objectCreate(protoOf(OuvrageTypeModel)));
  }
  function OuvrageTypeModel() {
  }
  protoOf(OuvrageTypeModel).k1y = function () {
    return this.h2h_1;
  };
  protoOf(OuvrageTypeModel).y2f = function () {
    return this.i2h_1;
  };
  protoOf(OuvrageTypeModel).h9 = function () {
    return this.j2h_1;
  };
  protoOf(OuvrageTypeModel).v2h = function () {
    return this.k2h_1;
  };
  protoOf(OuvrageTypeModel).w2h = function () {
    return this.l2h_1;
  };
  protoOf(OuvrageTypeModel).s2State = function () {
    return this.i2h_1;
  };
  protoOf(OuvrageTypeModel).s2Id = function () {
    return this.h2h_1;
  };
  protoOf(OuvrageTypeModel).toString = function () {
    return 'OuvrageTypeModel(id=' + this.h2h_1 + ', status=' + this.i2h_1 + ', name=' + this.j2h_1 + ', creationDate=' + toString(this.k2h_1) + ', updatedDate=' + toString(this.l2h_1) + ')';
  };
  protoOf(OuvrageTypeModel).hashCode = function () {
    var result = getStringHashCode(this.h2h_1);
    result = imul(result, 31) + this.i2h_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.j2h_1) | 0;
    result = imul(result, 31) + (this.k2h_1 == null ? 0 : this.k2h_1.hashCode()) | 0;
    result = imul(result, 31) + (this.l2h_1 == null ? 0 : this.l2h_1.hashCode()) | 0;
    return result;
  };
  protoOf(OuvrageTypeModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageTypeModel))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageTypeModel ? other : THROW_CCE();
    if (!(this.h2h_1 === tmp0_other_with_cast.h2h_1))
      return false;
    if (!this.i2h_1.equals(tmp0_other_with_cast.i2h_1))
      return false;
    if (!(this.j2h_1 === tmp0_other_with_cast.j2h_1))
      return false;
    if (!equals(this.k2h_1, tmp0_other_with_cast.k2h_1))
      return false;
    if (!equals(this.l2h_1, tmp0_other_with_cast.l2h_1))
      return false;
    return true;
  };
  function OuvrageTypePolicies() {
  }
  protoOf(OuvrageTypePolicies).canPage = function (authedUser) {
    return true;
  };
  protoOf(OuvrageTypePolicies).canGet = function (authedUser) {
    return true;
  };
  protoOf(OuvrageTypePolicies).canCreate = function (authedUser) {
    return hasRole(authedUser, 'Marque');
  };
  protoOf(OuvrageTypePolicies).canUpdate = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().h2g_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(OuvrageTypeUpdateCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.ouvrageType.domain.policy.OuvrageTypePolicies.canUpdate.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(OuvrageTypePolicies).canDelete = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().h2g_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(OuvrageTypeDeleteCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.ouvrageType.domain.policy.OuvrageTypePolicies.canDelete.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  var OuvrageTypePolicies_instance;
  function OuvrageTypePolicies_getInstance() {
    return OuvrageTypePolicies_instance;
  }
  function OuvrageTypeGetQueryDTO() {
  }
  function OuvrageTypeGetResponseDTO() {
  }
  function OuvrageTypePageQueryDTO() {
  }
  function OuvrageTypePageResponseDTO() {
  }
  //region block: post-declaration
  defineProp(protoOf(OuvrageTypeState), 'position', function () {
    return this.jr();
  }, function (value) {
    this.y2c(value);
  });
  defineProp(protoOf(OuvrageTypeState), 'name', protoOf(OuvrageTypeState).h9);
  defineProp(protoOf(OuvrageTypeState), 'ordinal', protoOf(OuvrageTypeState).i9);
  protoOf($serializer).xt = typeParametersSerializers;
  protoOf($serializer_0).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageTypeCreateCommand), 'name', function () {
    return this.h9();
  });
  protoOf($serializer_1).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageTypeCreatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OuvrageTypeCreatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(OuvrageTypeCreatedEvent), 'time');
  protoOf($serializer_2).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageTypeDeleteCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_3).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageTypeDeletedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OuvrageTypeDeletedEvent), 'time');
  protoOf($serializer_4).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageTypeImportCommand), 'item', function () {
    return this.q20();
  });
  protoOf($serializer_5).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageTypeImportedEvent), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(OuvrageTypeImportedEvent), 'time');
  protoOf($serializer_6).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageTypeUpdateCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OuvrageTypeUpdateCommand), 'name', function () {
    return this.h9();
  });
  protoOf($serializer_7).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageTypeUpdatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OuvrageTypeUpdatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(OuvrageTypeUpdatedEvent), 'time');
  protoOf($serializer_8).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageTypeModel), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OuvrageTypeModel), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(OuvrageTypeModel), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(OuvrageTypeModel), 'creationDate', function () {
    return this.v2h();
  });
  defineProp(protoOf(OuvrageTypeModel), 'updatedDate', function () {
    return this.w2h();
  });
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  OuvrageTypePolicies_instance = new OuvrageTypePolicies();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrageType = $org$boislocal$platform$s2.ouvrageType || ($org$boislocal$platform$s2.ouvrageType = {});
    var $org$boislocal$platform$s2$ouvrageType$domain = $org$boislocal$platform$s2$ouvrageType.domain || ($org$boislocal$platform$s2$ouvrageType.domain = {});
    var $org$boislocal$platform$s2$ouvrageType$domain$automate = $org$boislocal$platform$s2$ouvrageType$domain.automate || ($org$boislocal$platform$s2$ouvrageType$domain.automate = {});
    $org$boislocal$platform$s2$ouvrageType$domain$automate.OuvrageTypeState = OuvrageTypeState;
    $org$boislocal$platform$s2$ouvrageType$domain$automate.OuvrageTypeState.values = values;
    $org$boislocal$platform$s2$ouvrageType$domain$automate.OuvrageTypeState.valueOf = valueOf;
    defineProp($org$boislocal$platform$s2$ouvrageType$domain$automate.OuvrageTypeState, 'Exists', OuvrageTypeState_Exists_getInstance);
    defineProp($org$boislocal$platform$s2$ouvrageType$domain$automate.OuvrageTypeState, 'Deleted', OuvrageTypeState_Deleted_getInstance);
    defineProp($org$boislocal$platform$s2$ouvrageType$domain$automate.OuvrageTypeState, 'Companion', Companion_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrageType = $org$boislocal$platform$s2.ouvrageType || ($org$boislocal$platform$s2.ouvrageType = {});
    var $org$boislocal$platform$s2$ouvrageType$domain = $org$boislocal$platform$s2$ouvrageType.domain || ($org$boislocal$platform$s2$ouvrageType.domain = {});
    var $org$boislocal$platform$s2$ouvrageType$domain$command = $org$boislocal$platform$s2$ouvrageType$domain.command || ($org$boislocal$platform$s2$ouvrageType$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrageType = $org$boislocal$platform$s2.ouvrageType || ($org$boislocal$platform$s2.ouvrageType = {});
    var $org$boislocal$platform$s2$ouvrageType$domain = $org$boislocal$platform$s2$ouvrageType.domain || ($org$boislocal$platform$s2$ouvrageType.domain = {});
    var $org$boislocal$platform$s2$ouvrageType$domain$command = $org$boislocal$platform$s2$ouvrageType$domain.command || ($org$boislocal$platform$s2$ouvrageType$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrageType = $org$boislocal$platform$s2.ouvrageType || ($org$boislocal$platform$s2.ouvrageType = {});
    var $org$boislocal$platform$s2$ouvrageType$domain = $org$boislocal$platform$s2$ouvrageType.domain || ($org$boislocal$platform$s2$ouvrageType.domain = {});
    var $org$boislocal$platform$s2$ouvrageType$domain$command = $org$boislocal$platform$s2$ouvrageType$domain.command || ($org$boislocal$platform$s2$ouvrageType$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrageType = $org$boislocal$platform$s2.ouvrageType || ($org$boislocal$platform$s2.ouvrageType = {});
    var $org$boislocal$platform$s2$ouvrageType$domain = $org$boislocal$platform$s2$ouvrageType.domain || ($org$boislocal$platform$s2$ouvrageType.domain = {});
    var $org$boislocal$platform$s2$ouvrageType$domain$command = $org$boislocal$platform$s2$ouvrageType$domain.command || ($org$boislocal$platform$s2$ouvrageType$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrageType = $org$boislocal$platform$s2.ouvrageType || ($org$boislocal$platform$s2.ouvrageType = {});
    var $org$boislocal$platform$s2$ouvrageType$domain = $org$boislocal$platform$s2$ouvrageType.domain || ($org$boislocal$platform$s2$ouvrageType.domain = {});
    var $org$boislocal$platform$s2$ouvrageType$domain$model = $org$boislocal$platform$s2$ouvrageType$domain.model || ($org$boislocal$platform$s2$ouvrageType$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrageType = $org$boislocal$platform$s2.ouvrageType || ($org$boislocal$platform$s2.ouvrageType = {});
    var $org$boislocal$platform$s2$ouvrageType$domain = $org$boislocal$platform$s2$ouvrageType.domain || ($org$boislocal$platform$s2$ouvrageType.domain = {});
    var $org$boislocal$platform$s2$ouvrageType$domain$policy = $org$boislocal$platform$s2$ouvrageType$domain.policy || ($org$boislocal$platform$s2$ouvrageType$domain.policy = {});
    defineProp($org$boislocal$platform$s2$ouvrageType$domain$policy, 'OuvrageTypePolicies', OuvrageTypePolicies_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrageType = $org$boislocal$platform$s2.ouvrageType || ($org$boislocal$platform$s2.ouvrageType = {});
    var $org$boislocal$platform$s2$ouvrageType$domain = $org$boislocal$platform$s2$ouvrageType.domain || ($org$boislocal$platform$s2$ouvrageType.domain = {});
    var $org$boislocal$platform$s2$ouvrageType$domain$query = $org$boislocal$platform$s2$ouvrageType$domain.query || ($org$boislocal$platform$s2$ouvrageType$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrageType = $org$boislocal$platform$s2.ouvrageType || ($org$boislocal$platform$s2.ouvrageType = {});
    var $org$boislocal$platform$s2$ouvrageType$domain = $org$boislocal$platform$s2$ouvrageType.domain || ($org$boislocal$platform$s2$ouvrageType.domain = {});
    var $org$boislocal$platform$s2$ouvrageType$domain$query = $org$boislocal$platform$s2$ouvrageType$domain.query || ($org$boislocal$platform$s2$ouvrageType$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = $serializer_getInstance_8;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain.js.map
